export const types = {
    // Sync
    SET_CART_ID: "SET_CART_ID",
    SET_TOTAL: "SET_TOTAL",
    SET_CART_ITEMS: "SET_CART_ITEMS",
    REMOVE_ITEM: "REMOVE_ITEM",
    UPDATE_ITEM: "UPDATE_ITEM",
    EMPTY_CART: "EMPTY_CART",


    // Async    
    ADD_PRODUCT_TO_CART_ASYNC: "ADD_PRODUCT_TO_CART_ASYNC",
    GET_TOTAL_ASYNC: "GET_TOTAL_ASYNC",
    REMOVE_iTEM_ASYNC: "REMOVE_iTEM_ASYNC",
    UPDATE_iTEM_ASYNC: "UPDATE_iTEM_ASYNC",
    EMPTY_CART_ASYNC: "EMPTY_CART_ASYNC",


    CREATE_ORDER_ASYNC: "CREATE_ORDER_ASYNC",
};
